<template>
    <div class="size f12">{{showSize}}</div>
</template>

<script>
export default {
    props: {
        size: {
            type: Number,
            default: 0
        }
    },
    computed: {
        showSize(){
            if(this.size <= 0){
                return 0;
            }

            if(this.size < 1024){
                return this.size + 'B';
            }

            let unit = "K";
            
            if(this.size < 1024 * 1024){
                return (this.size / 1024).toFixed(2) + unit;
            }

            unit = "M";

            if(this.size < 1024 * 1024 * 1024){
                return (this.size / 1024 / 1024).toFixed(2) + unit;
            }

            unit = "G";

            return (this.size / 1024 / 1024 / 1024).toFixed(2) + unit;
        }
    },
    data(){
        return {

        }
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/FileSize.vue